<template>
  <div class="bulid-page">
    <img class="banner" src="@/assets/images/build/build-banner.png" alt="" />
    <div class="content">
      <div class="title">新型建筑工业化</div>
      <div class="build-list list" v-for="(item, index) in list" :key="index">
        <router-link :to="{ path: 'new-build-detail', query: { id: item.id } }">
          <div class="list-item">
            <img class="item-image" :src="item.url" alt="" />
            <div class="list-title">{{ item.title }}</div>
            <div class="list-content">{{ item.content }}</div>
            <div class="action">
              <div class="action-text">详细了解</div>
              <img
                class="atcion-icon"
                src="@/assets/images/build/build-icon.png"
                alt=""
              />
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      list: [],
    };
  },
    created(){
      this.initData();
    },
    methods: {

        async initData() {

            let contents = await this.$getContents(this.$channels.prefabricated);
            console.log("data.contents", contents)

            contents.forEach(
                item => {
                    this.list.push({
                        id: item.id,
                        url: process.env.VUE_APP_BASE_API + item.imageUrl,
                        title: item.title,
                        content: item.summary,
                        detail: item.body.replaceAll("/upload/images",process.env.VUE_APP_BASE_API+"/upload/images"),

                    })
                }
            );
        }
    },
};
</script>

<style scoped>
.content {
  padding: 100px 48px 39px 48px;
}
.banner {
  width: 100%;
}
.title {
  height: 67px;
  font-size: 48px;
  font-weight: bold;
  color: #333333;
  line-height: 67px;
  padding-bottom: 48px;
}

.list-item {
  margin-bottom: 98px;
}

.item-image {
  width: 100%;
}

.list-title {
  height: 50px;
  font-size: 36px;
  font-weight: bold;
  color: #424242;
  line-height: 50px;
  margin: 32px 0;
}

.list-content {
  font-size: 28px;
  font-weight: 400;
  color: #666666;
  line-height: 56px;
  margin-bottom: 29px;
}

.action {
  display: flex;
  height: 36px;
  align-items: center;
  cursor: pointer;
}

.action-text {
  height: 26px;
  font-size: 28px;
  font-weight: 400;
  color: #d8609e;
  line-height: 26px;
}

.atcion-icon {
  width: 36px;
  height: 36px;
}
</style>
